<template>
    <div class="expands">
        <div class="ex-menu">
            <strong class="tit text-primary">项目收款</strong>
            <ButtonGroup>
                <Button size="small" type="primary" class="text-font-sm" @click="addIncome(rowData.project_id, rowData.name, rowData.customer_id)"><Icon type="md-add" /> 创建收款</Button>
            </ButtonGroup>
        </div>
        <Table :stripe="true" border  size="small" :columns="columns" show-summary :summary-method="handleSummary" :data="rowData.incomeList" class="tables-x"  ref="selection" maxHeight="280" no-data-text="暂无数据记录">
            <template #sn="{ row }">
                <div class="d-width text-primary cursor" :title="row.sn" @click="showIncomeData(row.id)">
                    <span>{{row.sn}}</span>
                </div>
            </template>
            <template #tax_rate="{ row }">
                <span>{{row.tax_rate}} %</span>
            </template>
            <template #type_id="{ row }">
                <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                <span v-else>-</span>
            </template>
            <template #is_plan="{ row }">
                <Tag v-if="row.is_plan === 1" :color="row.plan_day <=0 && row.status !== 4 ?'red':'default'">{{row.plan_time}}</Tag>
                <span v-else>-</span>
            </template>
            <template #status="{ row }">
                <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                <Badge v-else-if="row.status === 2" color="orange" :text="row.status_name" />
                <Poptip v-else-if="row.status === 4" trigger="hover" width="240" :word-wrap="true" title="到账信息：" >
                    <Badge color="green" :text="row.status_name" />
                    <template #content>
                        <p style="white-space: normal;">金额：<span class="text-success">{{row.get_money}}</span></p>
                        <p style="white-space: normal;">时间：{{row.get_date}}</p>
                    </template>
                </Poptip>
                <Poptip v-else-if="row.status === 3" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                    <Badge color="red" :text="row.status_name" />
                    <template #content>
                        <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                        <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                    </template>
                </Poptip>
                <Badge v-else color="#999999" text="其他" />
            </template>
            <template #is_invoice="{ row }">
                <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
                <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
                <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
                <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
                <Badge v-else color="#999999" text="其他" />
            </template>
            <template #remark="{ row }">
                <div class="d-width" :title="row.remark">
                    <span>{{row.remark}}</span>
                </div>
            </template>
            <template #action="{ row, index }">
                <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) " @click="examineIncomeData(row.id, rowData.name)">{{row.status === 2 ? '重审':'审批'}}</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) "/>
                <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 4 && (row.is_invoice === 2 || row.is_invoice === 3)" @click="invoiceIncomeData(row.id, rowData.name)">开票</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 4 && (row.is_invoice === 2 || row.is_invoice === 3)"/>
                <a class="text-font-sm text-primary" @click="editIncomeData(row.id)" v-if="row.status !== 4 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)">编辑</a>
                <Divider type="vertical" v-if="row.status !== 4 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)"/>
                <a class="text-font-sm text-danger" v-if="row.status !== 4 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" @click="deleteIncomeData(row.id, index)">删除</a>
                <a class="text-font-sm text-success" @click="showIncomeData(row.id)" v-if="row.status == 4">查看</a>
            </template>
        </Table>
        <div class="ex-menu ex-menu-top">
            <strong class="tit text-orange">项目支出</strong>
            <ButtonGroup>
                <Button size="small" type="warning" class="text-font-sm" @click="addExpend(rowData.project_id, rowData.name)"><Icon type="md-add" /> 创建支出</Button>
            </ButtonGroup>
        </div>
        <Table :stripe="true" border  size="small" :columns="columns1" show-summary :summary-method="handleSummary1" :data="rowData.expendList" class="tables-x"  ref="selection" maxHeight="280" no-data-text="暂无数据记录">
            <template #sn="{ row }">
                <div class="d-width text-primary cursor" :title="row.sn" @click="showExpendData(row.expend_id)">
                    <span>{{row.sn}}</span>
                </div>
            </template>
            <template #buyer_id="{ row }">
                <div class="d-width" :title="row.buyer_title">
                    <span>{{row.buyer_title}}</span>
                </div>
            </template>
            <template #pay_time="{ row }">
                <span>{{!!row.pay_time?row.pay_time:'-'}}</span>
            </template>
            <template #pay_money="{ row }">
                <div class="d-width text-success" :title="row.pay_money">
                    <span>{{row.pay_money??'0.00'}}</span>
                </div>
            </template>
            <template #company="{ row }">
                <div class="d-width" :title="row.company">
                    <span>{{row.company}}</span>
                </div>
            </template>
            <template #type_id="{ row }">
                <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                <span v-else>-</span>
            </template>
            <template #status="{ row }">
                <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                <Badge v-else-if="row.status === 3" color="orange" :text="row.status_name" />
                <Badge v-else-if="row.status === 5" color="green" :text="row.status_name" />
                <Poptip v-else-if="row.status === 4 || row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                    <Badge color="red" :text="row.status_name" />
                    <template #content>
                        <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                        <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                    </template>
                </Poptip>
                <Badge v-else color="#999999" text="其他" />
            </template>
            <template #invoice_image="{ row }">
                <Badge v-if="row.invoice_image.length > 0" color="green" text="已上传" />
                <Badge v-else color="red" text="未上传" />
            </template>
            <template #remark="{ row }">
                <div class="d-width" :title="row.remark">
                    <span>{{row.remark}}</span>
                </div>
            </template>
            <template #action="{ row, index }">
                <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1 " @click="examineExpendData(row.expend_id)">审批</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1 "/>
                <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 " @click="payExpendData(row.expend_id)">打款</a>
                <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 "/>
                <a class="text-font-sm text-primary" v-if="row.status !== 5 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" @click="editExpendData(row.expend_id)">编辑</a>
                <Divider type="vertical" v-if="row.status !== 5 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)"/>
                <a class="text-font-sm text-danger" v-if="row.status !== 5 && ($store.state.userinfo.admin_id === row.apply_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" @click="deleteExpendData(row.expend_id, index)">删除</a>
                <a class="text-font-sm text-success" v-if="row.status === 5" @click="showExpendData(row.expend_id)">查看</a>
                <Divider type="vertical" v-if="row.invoice_image.length <= 0"/>
                <a class="text-font-sm text-orange" v-if="row.invoice_image.length <= 0" @click="addInvoiceData(row.expend_id)">发票</a>
            </template>
        </Table>

        <!-- 项目收款  -->
        <add-income-modal v-if="is_income_add" ref="AddIncomeRef" @trueHandler="saveData"></add-income-modal>

        <!-- 财务入账审批  -->
        <examine-income-modal v-if="is_income_examine" ref="ExamineIncomeRef" @trueHandler="saveData"></examine-income-modal>

        <!-- 收款详情  -->
        <show-income-modal v-if="is_income_show" ref="ShowIncomeRef"></show-income-modal>

        <!-- 开发票  -->
        <invoice-income-modal v-if="is_income_invoice" ref="InvoiceIncomeRef" @trueHandler="saveData"></invoice-income-modal>

        <!-- 项目支出  -->
        <add-expend-modal v-if="is_expend_add" ref="AddExpendRef" @trueHandler="saveData"></add-expend-modal>

        <!-- 项目支出审批  -->
        <examine-expend-modal v-if="is_expend_examine" ref="ExamineExpendRef" @trueHandler="saveData"></examine-expend-modal>

        <!-- 项目支出财务打款  -->
        <pay-expend-modal v-if="is_expend_pay" ref="PayExpendRef" @trueHandler="saveData"></pay-expend-modal>

        <!-- 项目支出详情  -->
        <show-expend-modal v-if="is_expend_show" ref="ShowExpendRef"></show-expend-modal>

        <!-- 上传支出发票  -->
        <invoice-expend-modal v-if="is_expend_invoice" ref="InvoiceExpendRef" @trueHandler="saveData"></invoice-expend-modal>
    </div>

</template>

<script>

import AddIncomeModal from "@/view/income/Collection";
import ExamineIncomeModal from "@/view/income/Examine";
import InvoiceIncomeModal from "@/view/income/Invoice";
import ShowIncomeModal from "@/view/income/Show";
import AddExpendModal from "@/view/expend/Expend";
import ExamineExpendModal from "@/view/expend/Examine";
import PayExpendModal from "@/view/expend/Pay";
import ShowExpendModal from "@/view/expend/Show";
import invoiceExpendModal from "@/view/expend/Invoice";
import {deleteIncome} from "@/apis/income";
import {deleteExpend} from "@/apis/expend";



export default {
    props: {
        rowData: {
            type: Object
        }
    },
    components: {
        AddIncomeModal, ExamineIncomeModal, InvoiceIncomeModal, AddExpendModal, ExamineExpendModal, PayExpendModal, ShowExpendModal, ShowIncomeModal, invoiceExpendModal
    },
    emits: ['reloadData'],
    data () {
        return {
            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width : 150
                },
                {
                    title: '金额',
                    key: 'money',
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate'
                },
                {
                    title: '税费',
                    key: 'tax_money',
                },
                {
                    title: '实收',
                    key: 'true_money',
                },
                {
                    title: '类型',
                    key: 'type_id',
                    slot: 'type_id',
                },
                {
                    title: '计划收款',
                    key: 'is_plan',
                    slot: 'is_plan',
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '发票',
                    key: 'is_invoice',
                    slot: 'is_invoice',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 150
                }

            ],
            columns1: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width : 150
                },
                {
                    title: '采购信息',
                    key: 'buyer_id',
                    slot: 'buyer_id',
                },
                {
                    title: '支出金额',
                    key: 'money'
                },
                {
                    title: '支出类型',
                    key: 'type_id',
                    slot: 'type_id'
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                },
                {
                    title: '发票',
                    key: 'invoice_image',
                    slot: 'invoice_image',
                },
                {
                    title: '已付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                },
                {
                    title: '付款时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                },
                {
                    title: '供应商',
                    key: 'company',
                    slot: 'company',
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark'
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    // fixed : 'right',
                    width : 190
                }

            ],
            is_add_expend :false,
            is_apply: false,
            is_income_add: false,
            is_income_examine: false,
            is_income_invoice: false,
            is_income_show: false,
            is_expend_add: false,
            is_expend_examine: false,
            is_expend_pay: false,
            is_expend_show: false,
            is_expend_invoice: false,
        }
    },
    created(){

    },
    methods: {
        /**
         功能：
         time: 2025/12/26 17:54
         **/
        addExpend(project_id, name){
            let that = this;
            that.is_expend_add = true;
            setTimeout(function(){
                that.$refs.AddExpendRef.add(project_id, name);
            })
        },
        addInvoiceData(project_id){
            let that = this;
            that.is_expend_invoice = true;
            setTimeout(function(){
                that.$refs.InvoiceExpendRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 10:22
         **/
        editExpendData(expend_id){
            let that = this;
            that.is_expend_add = true;
            setTimeout(function(){
                that.$refs.AddExpendRef.edit(expend_id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showExpendData(expend_id){
            let that = this;
            that.is_expend_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 10:33
         **/
        deleteExpendData(expend_id, index){
            let that = this;
            if(!expend_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteExpend(expend_id).then( e =>{
                        that.rowData.expendList.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2025/12/27 10:54
         **/
        examineExpendData(expend_id){
            let that = this;
            that.is_expend_examine = true;
            setTimeout(function(){
                that.$refs.ExamineExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/27 11:35
         **/
        payExpendData(expend_id){
            let that = this;
            that.is_expend_pay = true;
            setTimeout(function(){
                that.$refs.PayExpendRef.show(expend_id);
            })
        },
        /**
         功能：
         time: 2025/12/26 15:40
         **/
        examineIncomeData(id, project_name){
            let that = this;
            that.is_income_examine = true;
            setTimeout(function(){
                that.$refs.ExamineIncomeRef.show(id, project_name);
            })
        },
        /**
         功能：
         time: 2025/12/26 15:40
         **/
        invoiceIncomeData(id, project_name){
            let that = this;
            that.is_income_invoice = true;
            setTimeout(function(){
                that.$refs.InvoiceIncomeRef.add(id, project_name);
            })
        },
        /**
         功能：新增收款
         time: 2025/12/26 10:45
         **/
        addIncome(project_id, name, customer_id){
            let that = this;
            that.is_income_add = true;
            setTimeout(function(){
                that.$refs.AddIncomeRef.add(project_id, name, customer_id, 1);
            })
        },
        /**
         功能：编辑收款
         time: 2025/12/26 10:46
         **/
        editIncomeData(id){
            let that = this;
            that.is_income_add = true;
            setTimeout(function(){
                that.$refs.AddIncomeRef.edit(id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showIncomeData(id){
            let that = this;
            that.is_income_show = true;
            setTimeout(function(){
                that.$refs.ShowIncomeRef.show(id);
            })
        },
        /**
         功能：删除收款
         time: 2025/12/26 10:46
         **/
        deleteIncomeData(id, index){
            let that = this;
            if(!id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteIncome(id).then( e =>{
                        that.rowData.incomeList.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：
         time: 2025/12/27 13:52
         **/
        saveData(){
            this.$emit('reloadData', this.rowData.project_id);
        },
        /**
         功能：
         time: 2025/12/27 13:52
         **/
        handleSummary ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 1 || index === 3 || index === 4){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },
        /**
         功能：
         time: 2025/12/27 13:52
         **/
        handleSummary1 ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 2 || index === 6){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },

    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.expands{
    padding: 15px 15px 20px !important;
    background: #ddd !important;
    width: calc(100vw - 242px);

    .ex-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &.ex-menu-top {
            margin-top: 20px;
        }
    }
}
</style>
